import styled from 'styled-components';
import { pxToRem, margin, padding } from '../../styles/mixins';

interface Props {
  $isActive?: boolean
  $hasNewPurchase?: boolean
}

export const Container = styled.div`
  ${margin(48, 'auto', 0)};
  max-width: 1295px;
  width: 100%;
  
	@media screen and (max-width: 1365px) {
		padding: 0 10px;
	}
`
export const Title = styled.h2`
  ${pxToRem(18)};
  font-weight: 700;
  ${margin(0, 0, 18, 0)};
`
export const TitleError = styled.h2`
  ${pxToRem(56)};
  font-weight: 400;
  ${margin(0, 0, 18, 0)};
  color: var(--ins-blue);
`

export const TextSugestions = styled.p`
  ${pxToRem(16)};
  ${margin(34, 0, 20, 0)};
  font-weight: 400;
  color: var(--gray-900);
`

export const ParagraphError = styled.p`
  ${pxToRem(20)};
  ${margin(0, 0, 12, 0)};
  font-weight: 400;
  color: var(--black);
`

export const Paragraph = styled.p`
  ${pxToRem(20)};
  ${margin(0, 0, 12, 0)};
  font-weight: 400;
  color: var(--gray-600);
`

export const ListErrors = styled.ul`
  list-style: disc;
  ${padding(0, 0, 0, 20)};
  ${margin(0, 0, 50, 0)};

  li {
    margin-bottom: 10px;
  }
`

export const List = styled.ul`
  list-style: none;
  ${margin(0, 0, 30, 0)};
`

export const ListItem = styled.li`
  ${pxToRem(16)};
  font-weight: 600;
  color: var(--ins-blue);
  ${margin(0,0,10,0)};
`
export const OffersTypeButtonsGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const ButtonErrors = styled.button<Props>`
  width: 100%;
  height: 42px;
  max-width: 208px;
  background-color: var(--ins-blue);
  border: none;
  border-radius: 8px;
  color: var(--white);
  ${pxToRem(16)};
  font-weight: 700;
  transition: .2s;

	&:hover {
		background-color:#583eff;
    color: var(--white);
	}
`

export const Button = styled.button<Props>`
  width: 100%;
  height: 77px;
  max-width: ${({ $hasNewPurchase }) => ($hasNewPurchase ? '30%' : '615px')};
  background-color: ${({ $isActive }) => ($isActive ? 'var(--ins-blue)': 'var(--gray-300)')};
  border: none;
  border-radius: 8px 8px 0 0;
  color: ${({ $isActive }) => ($isActive ? 'var(--white)': 'var(--gray-600)')};
  ${pxToRem(24)};
  font-weight: 700;
  transition: .2s;

  @media screen and (max-width: 1280px) {
    max-width: ${({ $hasNewPurchase }) => ($hasNewPurchase ? '30%' : '48%')};
    ${pxToRem(16)};
  }

	&:hover {
		background-color:#583eff;
    color: var(--white);
	}
`